/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_Reset_TooltipInputs */

const en_interview_attendance_reset_tooltip = /** @type {(inputs: Interview_Attendance_Reset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click again to reset confirmation`)
};

const de_interview_attendance_reset_tooltip = /** @type {(inputs: Interview_Attendance_Reset_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut klicken, um die Bestätigung zurückzusetzen`)
};

/**
* | output |
* | --- |
* | "Click again to reset confirmation" |
*
* @param {Interview_Attendance_Reset_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_reset_tooltip = /** @type {((inputs?: Interview_Attendance_Reset_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_Reset_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_reset_tooltip(inputs)
	return en_interview_attendance_reset_tooltip(inputs)
});